export const IGNORED_MESSAGES = ['Abort due to cancellation of share'];
